export const awsExports = {
    REGION: 'eu-west-1',
    USER_POOL_ID: process.env.REACT_APP_COGNITO_POOL_ID,
    USER_POOL_CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID,
    DOMAIN: process.env.REACT_APP_COGNITO_DOMAIN
}